import { render, staticRenderFns } from "./NewProduct.vue?vue&type=template&id=14bdcd5e&scoped=true"
import script from "./NewProduct.vue?vue&type=script&lang=js"
export * from "./NewProduct.vue?vue&type=script&lang=js"
import style0 from "./NewProduct.vue?vue&type=style&index=0&id=14bdcd5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bdcd5e",
  null
  
)

export default component.exports